export default "__VITE_ASSET__CVHZ41W4__"